import { useRef, useState } from 'react';
import styled from 'styled-components';
import { closeModal } from '../../../services/modal';
import { addTask, editTask, getTaskTypeDisplayName, removeTask, TaskDifficulty, TaskProps, TaskType, taskTypeDisplayName } from '../../../services/task';
import Button, { ButtonColor, ButtonSize } from '../../../ui/Button';
import Input, { InputSize, InputType } from '../../../ui/Input/Input';
import MenuOption from '../../../ui/Menu/MenuOption';
import { deepClone } from '../../../utils/utils';
import Icon from '../../../ui/Icon';
import TaskEditDifficulty from './TaskEditDifficulty';
import TaskEditRewards from './TaskEditRewards';
import Popover, { DropperRefProps } from '../../../ui/Popover/Popover';
import Menu from '../../../ui/Menu/Menu';
import Separator, { SeparatorOrientation } from '../../../ui/Separator';
import { getStoreValue, stores } from '../../../utils/store';

interface TaskEditProps {
    task?: TaskProps;
}

export default function TaskEdit(props: TaskEditProps) {
    const menuButtonRef = useRef<HTMLElement>(null);
    const menuPopoverRef = useRef<DropperRefProps>(null);
    const task: { current: TaskProps } = useRef((props.task ? deepClone(props.task) : getEmptyTask()) as TaskProps);
    const [reRender, setReRender] = useState(false);

    function getEmptyTask(): TaskProps {
        return { date: (new Date()).getHours() >= 21 ? Date.now() + 12 * 60 * 60 * 1000 : Date.now() } as TaskProps;
    }

    function done() {
        if (!task.current.difficulty) task.current.difficulty = TaskDifficulty.LVL_0;

        if (!task.current.id) addTask(task.current);
        if (task.current.id) editTask(task.current);

        closeModal();
        console.log(task.current);
    }

    function remove() {
        removeTask(task.current.id);
        closeModal();
    }

    // function edit(attributes: { [K in keyof TaskProps]?: TaskProps[K] }) {
    //     setIsEdited(true);
    //     Object.keys(attributes).forEach((key: any) => {
    //         task.current[key as never] = attributes[key as never];
    //     })
    // }

    //TODO: SHOULD BE DROP DOWN WITH NAMES AND WHEN YOU CLICK IT SETS
    function autoFill() {
        if (task.current.id) return;
        const previousTasks = getStoreValue(stores.tasksByName);
        if (previousTasks[task.current.name]) {
            setReRender(!reRender);
            console.log("Previous task with same name detected!");

            // debugger;

            const previousTask = deepClone(previousTasks[task.current.name]);
            delete (previousTask as any).id;
            previousTask.date = task.current.date;
            previousTask.done = false;

            task.current = previousTask;
        }
    }

    return (
        <Wrapper>
            <Input value={task.current.name} onChange={value => { task.current.name = value; autoFill(); }} size={InputSize.LARGE} type={InputType.INPUT} limit={50} name='Task Name' className='name'></Input>
            <Input displayNames={taskTypeDisplayName} value={task.current.type} onChange={value => task.current.type = value} size={InputSize.LARGE} type={InputType.SELECT} name='Type' className='type'>
                <MenuOption value={TaskType.GOAL}>{getTaskTypeDisplayName(TaskType.GOAL)}</MenuOption>
                <MenuOption value={TaskType.REPETITIVE}>{getTaskTypeDisplayName(TaskType.REPETITIVE)}</MenuOption>
                <MenuOption value={TaskType.ONEOFF}>{getTaskTypeDisplayName(TaskType.ONEOFF)}</MenuOption>
            </Input>

            <TaskEditDifficulty difficulty={task.current.difficulty || TaskDifficulty.LVL_0} onChange={value => task.current.difficulty = value} className='difficulty'></TaskEditDifficulty>

            <Input value={task.current.date} onChange={value => task.current.date = value} size={InputSize.LARGE} type={InputType.DATE} name='Date' className='date'></Input>
            <Input value={task.current.duration} onChange={value => task.current.duration = value} size={InputSize.LARGE} type={InputType.NUMBER} name='Duration' rightOrnament='Minutes' className='duration'></Input>

            <TaskEditRewards rewards={task.current.rewards} onChange={rewards => task.current.rewards = rewards} className='reward'></TaskEditRewards>

            <Input value={task.current.description} onChange={value => task.current.description = value} size={InputSize.LARGE} type={InputType.TEXT} limit={600} name='Description' className='description'></Input>

            <div className='save flex center padding-10'>
                <Button onClick={done} size={ButtonSize.MEDIUM} color={ButtonColor.PRIMARY}>Done</Button>
            </div> {/* shouldnt be in taskEdit */}

            {task.current.id && <div className='delete flex right padding-10'>
                <Button ref={menuButtonRef} leftOrnament={<Icon icon='more-3' size={20}></Icon>} onClick={() => menuPopoverRef.current?.open()} size={ButtonSize.MEDIUM} color={ButtonColor.TRANSPARENT}></Button>
                <Popover ref={menuPopoverRef} targetRef={menuButtonRef}>
                    <Menu>
                        {/* <MenuOption onClick={() => { }}>Duplicate</MenuOption>
                        <MenuOption onClick={() => { }}>History</MenuOption>
                        <Separator orientation={SeparatorOrientation.HORIZONTAL} spacing={10} offset='40%'></Separator> */}
                        <MenuOption style={{ color: 'rgb(184, 30, 68)' }} icon='trash-4' onClick={() => { remove(); menuPopoverRef.current?.close() }}>Remove</MenuOption>
                    </Menu>
                </Popover>
            </div>}

        </Wrapper >
    )
}

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 3fr 3fr 3fr 3fr;
    grid-template-rows: auto minmax(200px, auto) auto auto auto;
    grid-template-areas: 
    'name name name type'
    'difficulty difficulty difficulty difficulty'
    'date date duration duration'
    'reward reward reward reward'
    'description description description description'
    '. save save delete'
    ;
    gap: 10px;

    .name { grid-area: name; }
    .type { grid-area: type; }
    .date { grid-area: date; }
    .duration { grid-area: duration; }
    .difficulty { grid-area: difficulty}
    .reward { grid-area: reward; margin: 10px 0 0 0}
    .description { grid-area: description; }
    .save { grid-area: save; }
    .delete {grid-area: delete; }

`